import { connect } from 'react-redux'
import * as action from '../../state/plan/action'
import * as selector from '../../state/plan/selector'
import TreatmentPlan from '../plan/TreatmentPlan'

const mapStateToProps = (state, props) => {
    return {
        treatmentPlan: selector.selectTreatmentPlan(state),
    }
}

const mapDispatchToProps = {
    changeTreatmentPlan: action.changeTreatmentPlan,
    changeExistingCondition: action.changeExistingCondition,
    changeInstruction: action.changeInstruction,
    changeDoNotMove: action.changeDoNotMove,
    changeLeaveSpaceOpen: action.changeLeaveSpaceOpen,
    saveTreatmentPlan: action.saveTreatmentPlan,
}


export default connect(mapStateToProps, mapDispatchToProps)(TreatmentPlan)



// WEBPACK FOOTER //
// ./src/modules/treatment/component/task-widget/TreatmentPlanWidgetContainer.js